import intro1 from '@images/intro/intro-1.png';
import intro2 from '@images/intro/intro-2.png';
import intro3 from '@images/intro/intro-3.png';
import intro4 from '@images/intro/intro-4.png';

export const authSlideImages = [intro1, intro2, intro3, intro4];
